import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Button, Card, CardHeader, CardBody, Col, Row } from "reactstrap";
import OrderManagementService from "../../../Services/QRCodeServices/Order Management/OrderManagementService";
import { useParams } from "react-router-dom";
import OrderProduct from "./OrderProduct";
import BillDownload from "./BillDownload";
import TimelinePopup from "./TimelinePopup";

const ReceivedOrderDetail = () => {
  const [data, setData] = useState({});
  const { id } = useParams();
  const [menuItem, setMenuItem] = useState({});
  const [billModal, setBillModal] = useState(false); // State for bill download modal
  const [timelineModal, setTimelineModal] = useState(false); // State for timeline modal

  // Fetch order details
  useEffect(() => {
    (async () => {
      try {
        const response = await OrderManagementService.detail(id);
        setData(response);
        setMenuItem(response);
      } catch (error) {
        console.log("🚀 ~ error:", error);
      }
    })();
  }, [id]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Order Management"
          title="Order Management Detail"
          breadcrumbItems={[
            { title: "Back To List ", link: "/order-management" },
          ]}
        />

        {/* Order Details */}
        <Row>
          <Col xl={12} xs={12} md={12}>
            <Card>
            <CardHeader>
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center align-items-start gap-3">
    {/* Left Section: Order Details */}
    <div className="d-flex flex-column gap-2">
      <h5 className="card-title mb-0 text-primary">
        Order #{menuItem?.orderRef}
      </h5>
      <div className="d-flex flex-column flex-md-row gap-2 gap-md-4">
        <div className="d-flex align-items-center gap-2">
          <i className="ri-calendar-line text-muted"></i>
          <span className="text-muted">Created Date:</span>
          <span className="fw-medium">{menuItem?.createdDate}</span>
        </div>
        <div className="d-flex align-items-center gap-2">
        <i class="ri-user-line"></i>
          <span className="text-muted">Customer Contact:</span>
          <span className="fw-medium">
            {menuItem?.customerContact || "N/A"}
          </span>
        </div>
      </div>
    </div>

    {/* Right Section: Buttons */}
    <div className="d-flex gap-2">
      <Button
        color="success"
        size="sm"
        className="d-flex align-items-center"
        onClick={() => setBillModal(true)}
      >
        <i className="ri-download-2-fill align-middle me-2"></i>
        Download Invoice
      </Button>
      <Button
        color="info"
        size="sm"
        className="d-flex align-items-center"
        onClick={() => setTimelineModal(true)}
      >
        <i className="ri-history-line align-middle me-2"></i>
        View Timeline
      </Button>
    </div>
  </div>
</CardHeader>
              <CardBody>
                <div className="table-responsive table-card">
                  <table className="table table-nowrap align-middle table-borderless mb-0">
                    <thead className="table-light text-muted">
                      <tr>
                        <th scope="col">Product Details</th>
                        <th scope="col">Item Price</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Order Status</th>
                        <th scope="col" className="text-end">Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <OrderProduct menuItem={menuItem} />
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Bill Download Modal */}
        <BillDownload isOpen={billModal} toggle={() => setBillModal(!billModal)} menuItem={menuItem} />

        {/* Timeline Popup */}
        <TimelinePopup isOpen={timelineModal} toggle={() => setTimelineModal(!timelineModal)} statusLogs={menuItem?.statusLogDtos} orderRef={menuItem?.orderRef}  />
      </div>
    </div>
  );
};

export default ReceivedOrderDetail;